export default {
  // Navigation
  "nav.home": "Início",
  "nav.about": "Sobre Nós",
  "nav.services": "Serviços",
  "nav.contact": "Contacto",
  "nav.lang": "Idioma",

  // Footer
  "footer.rights": "DEIASPART. Todos os direitos reservados.",
  "footer.address": "Avenida CDTE Gika n116, Alvalade, Maianga",
  "footer.followUs": "Siga-nos",
  "footer.links": "Links",
  "footer.services": "Serviços",
  "footer.nif": "NIF",
  "footer.developedBy": "Desenvolvido e Mantido por:",

  // Home - Hero
  "home.hero.subtitle": "Engenharia & Construção Civil",
  "home.hero.tagline": "Soluções orientadas para a eficiência desde 2017",
  "home.hero.ctaServices": "Os Nossos Serviços",
  "home.hero.ctaContact": "Contacte-nos",
  "home.hero.slide2.title": "Soluções Perfeitas",
  "home.hero.slide3.title": "11 Serviços",
  "hero.carousel.prev": "Slide anterior",
  "hero.carousel.next": "Próximo slide",
  "hero.carousel.goto": "Ir para o slide",

  // Home - About
  "home.about.title": "Sobre a DEIASPART",
  "home.about.text1": "A DEIASPART é uma empresa que opera no sector de engenharia e obras de construção civil, nas áreas de reabilitação, instalação, manutenção e assistência técnica, gestão de condomínios e edifícios.",
  "home.about.text2": "Fundada em 2017, a DEIASPART oferece soluções orientadas para a eficiência onde competências específicas são valorizadas, proporcionando um conjunto de serviços integrados que garantem o bom funcionamento das suas instalações.",
  "home.about.cta": "Saiba Mais",
  "home.about.since": "Desde 2017",
  "home.about.location": "Luanda, Angola",

  // Home - Services
  "home.services.title": "Os Nossos Serviços",
  "home.services.subtitle": "Competências integradas para o seu projecto",
  "home.services.viewAll": "Ver Todos os Serviços",
  "home.services.additionalTitle": "Serviços Adicionais",

  "service.mechanical.name": "Torno Mecânico",
  "service.mechanical.desc": "Fabrico de peças mecânicas, peças em nylon, rebobinagem de motores e manutenção de máquinas metalúrgicas.",

  "service.electricity.name": "Electricidade",
  "service.electricity.desc": "Instalação e manutenção de redes eléctricas, reparação de geradores, instalação em média e baixa tensão.",

  "service.hydraulic.name": "Hidráulica",
  "service.hydraulic.desc": "Reparação e manutenção de redes de água, bombas submersíveis e sistemas de tratamento de água.",

  "service.electromechanics.name": "Electromecânica",
  "service.electromechanics.desc": "Manutenção de elevadores e escadas rolantes, sistemas de alarme de incêndio, extractores automáticos e portões.",

  "service.hvac.name": "HVAC",
  "service.hvac.desc": "Montagem e manutenção de HVAC, sistemas de insuflação e pressurização de ar, reparação de sistemas Schiller e VRV.",

  "service.electronics.name": "Electricidade & Electrónica",
  "service.electronics.desc": "Reparação de equipamentos electrónicos, manutenção de portões eléctricos, CCTV e segurança electrónica.",

  "service.tickets.name": "Bilhetes de Passagem",
  "service.tickets.desc": "Reserva de bilhetes de avião para destinos nacionais e internacionais com atendimento personalizado.",

  "service.tourism.name": "Tour Turismo",
  "service.tourism.desc": "Pacotes turísticos e tours guiados para descobrir as maravilhas de Angola e do mundo.",

  "service.office.name": "Materiais de Escritório",
  "service.office.desc": "Fornecimento de materiais e equipamentos de escritório para empresas e particulares.",

  "service.visas.name": "Tratamento de Vistos",
  "service.visas.desc": "Assessoria completa para obtenção de vistos de viagem, trabalho e residência.",

  "service.rentacar.name": "Renta Car",
  "service.rentacar.desc": "Aluguer de viaturas para particulares e empresas com diversas opções de frota.",

  // Home - Why Choose Us
  "home.why.title": "Porquê Escolher a DEIASPART?",
  "home.why.response": "Capacidade de Resposta",
  "home.why.responseDesc": "Correcção, controlo, instalação e gestão de operações, validando o desempenho e qualidade das intervenções.",
  "home.why.assistance": "Assistência Técnica 24/7",
  "home.why.assistanceDesc": "Serviços programados de acordo com a disponibilidade dos nossos clientes, com atendimento 24/7 em deslocação sem custos em serviços de assistência de emergência.",
  "home.why.experience": "Experiência Consolidada",
  "home.why.experienceDesc": "Mais de 8 anos de actuação no mercado angolano, com referências sólidas e clientes satisfeitos.",

  // Home - Clients
  "home.clients.title": "Clientes e Parceiros",
  "home.clients.subtitle": "Empresas e organizações que confiam na DEIASPART",

  // Home - CTA
  "home.cta.title": "Pronto para iniciar o seu projecto?",
  "home.cta.subtitle": "Entre em contacto connosco e solicite um orçamento sem compromisso.",
  "home.cta.button": "Solicitar Orçamento",
  "home.cta.mailSubject": "Solicitação de Orçamento",

  // About page
  "about.hero.title": "Sobre Nós",
  "about.hero.subtitle": "Conheça a história e a missão da DEIASPART",

  "about.story.title": "A Nossa História",
  "about.story.text1": "O grupo DEIASPART tem vindo a construir uma trajetória de caminhos para consolidar de forma sustentável a sua referência e economia, nas actividades de Manutenção e Assistência Técnica nas diversas áreas da Engenharia e Reabilitação.",
  "about.story.text2": "Temos feito um percurso com ambição e determinação visando os nossos objectivos e oferecendo os melhores serviços. Estamos focados em alcançar bons resultados e melhorar a nossa posição no mercado em que operamos, mantendo o foco na superação de barreiras, inovação e otimismo na nossa forma de pensar e agir.",

  "about.mission.title": "Missão",
  "about.mission.text": "Oferecer soluções orientadas para a eficiência onde competências específicas são valorizadas, proporcionando um conjunto de serviços integrados que garantem o bom funcionamento das instalações dos nossos clientes.",

  "about.vision.title": "Visão",
  "about.vision.text": "Ser referência nacional em engenharia e construção civil, reconhecidos pela qualidade, inovação e compromisso com a satisfação dos clientes.",

  "about.values.title": "Valores",
  "about.values.integrity": "Integridade",
  "about.values.integrityDesc": "Actuamos com ética, transparência e responsabilidade em todas as nossas relações.",
  "about.values.excellence": "Excelência",
  "about.values.excellenceDesc": "Comprometemo-nos com a qualidade superior e a melhoria contínua dos nossos serviços.",
  "about.values.innovation": "Inovação",
  "about.values.innovationDesc": "Adoptamos novas tecnologias e métodos para oferecer soluções cada vez mais eficientes.",
  "about.values.commitment": "Compromisso",
  "about.values.commitmentDesc": "Cumprimos os nossos prazos e garantimos a satisfação total dos nossos clientes.",

  "about.stats.years": "Anos de Experiência",
  "about.stats.services": "Serviços",
  "about.stats.clients": "Clientes Satisfeitos",
  "about.stats.support": "Assistência 24/7",

  // Services page
  "services.hero.title": "Os Nossos Serviços",
  "services.hero.subtitle": "Soluções integradas de engenharia e serviços adicionais",

  "services.engineering.title": "Serviços de Engenharia",
  "services.engineering.desc": "Prestação de serviços técnicos especializados nas diversas áreas da engenharia, com equipas qualificadas e materiais de qualidade.",

  "services.additional.title": "Serviços Adicionais",
  "services.additional.desc": "Serviços complementares para facilitar a vida dos nossos clientes, desde viagens até logística de escritório.",

  "services.cta.text": "Precisa de algum destes serviços?",
  "services.cta.button": "Contacte-nos Agora",
  "services.card.request": "Solicitar",

  "services.detail.mechanical": "Fabrico de peças mecânicas personalizadas, fabrico de peças em nylon para diversas aplicações industriais, rebobinagem de motores eléctricos e manutenção de máquinas metalúrgicas.",
  "services.detail.electricity": "Instalação e manutenção de redes eléctricas em edifícios residenciais e comerciais, manutenção e reparação de geradores, instalações em média e baixa tensão, montagem e leitura de esquemas eléctricos, montagem de tomadas, interruptores e quadros de distribuição.",
  "services.detail.hydraulic": "Reparação e manutenção de redes de água potável e esgotos, manutenção de bombas submersíveis, instalação de sistemas de tratamento de água para consumo humano e industrial, e construção de equipas especializadas.",
  "services.detail.electromechanics": "Manutenção preventiva e correctiva de elevadores e escadas rolantes, instalação e manutenção de sistemas de alarme de incêndio e detecção (SADI), extractores automáticos de ar para ambientes industriais e domésticos, sistemas de pressurização de ar, e instalação e manutenção de portões automáticos.",
  "services.detail.hvac": "Montagem e manutenção de sistemas HVAC (Heating, Ventilation and Air Conditioning), sistemas de insuflação e pressurização de ar para edifícios comerciais e industriais, reparação de sistemas Schiller e VRV (Variable Refrigerant Volume).",
  "services.detail.electronics": "Reparação de equipamentos electrónicos diversos, manutenção de portões eléctricos e torniquetes, instalação e manutenção de sistemas CCTV e segurança electrónica.",
  "services.detail.tickets": "Reserva de bilhetes de avião para destinos nacionais e internacionais. Atendimento personalizado para encontrar as melhores opções de voo aos melhores preços.",
  "services.detail.tourism": "Organização de pacotes turísticos e tours guiados para explorar as belezas de Angola e destinos internacionais. Experiências memoráveis com guias profissionais.",
  "services.detail.office": "Fornecimento de materiais de escritório incluindo papelaria, mobiliário, equipamentos informáticos e consumíveis para empresas e particulares.",
  "services.detail.visas": "Assessoria completa no processo de obtenção de vistos de viagem, trabalho e residência. Acompanhamento documental e apoio em todas as fases do processo.",
  "services.detail.rentacar": "Aluguer de viaturas de passageiros e comerciais para particulares e empresas. Frota diversificada com opções de curto e longo prazo.",

  // Contact page
  "contact.hero.title": "Contacto",
  "contact.hero.subtitle": "Estamos prontos para o ajudar. Entre em contacto connosco.",

  "contact.info.title": "Informações de Contacto",
  "contact.info.address": "Morada",
  "contact.info.addressValue": "Avenida CDTE Gika n116, Alvalade, Maianga, Luanda, Angola",
  "contact.info.phones": "Telefones",
  "contact.info.emails": "E-mails",
  "contact.info.nif": "NIF",

  "contact.services.title": "Solicitar Serviço por E-mail",
  "contact.services.subtitle": "Clique no serviço desejado para nos enviar um e-mail",
  "contact.services.emailSubject": "Solicitação de Serviço - ",

  "contact.cta.title": "Prefere falar connosco?",
  "contact.cta.text": "A nossa equipa está disponível para o atender. Contacte-nos por telefone ou e-mail e responderemos com a maior brevidade possível.",

  // Common
  "common.readMore": "Ler Mais",
  "common.send": "Enviar",
  "common.sending": "A enviar...",
  "common.success": "Mensagem enviada com sucesso!",
  "common.error": "Ocorreu um erro. Tente novamente.",
  "common.required": "Campo obrigatório",
  "common.emailInvalid": "E-mail inválido",
  "common.phone": "Telefone",
  "common.email": "E-mail",
  "common.name": "Nome",
  "common.message": "Mensagem",
  "common.close": "Fechar",
};